import { getStatistics } from 'sagas/firebase'
import { call, takeLatest } from 'redux-saga/effects'

export function* checkIfStatisticsShouldBeDownloaded() {
  // Yes, since the cover art needs them, they should always be downloaded
  yield call(getStatistics)
}

export function* checkforStatisticsDownloadAfterRehydration() {
  yield takeLatest('persist/REHYDRATE', checkIfStatisticsShouldBeDownloaded)
}
